import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionCard',
  props: {
    items: { default: () => [] }
  },
  emits: [],
  setup(__props: any, { emit }) {

const props = __props as { items: { title: string; description: string }[] };




const panel: number[] = [];

return { __sfc: true,emit, props, panel }
}

})